module.exports = __webpack_public_path__ + "static/media/waitforyou.80901948.png";